import React, { useState } from "react";
import AudioPlayer from "./call-logs/AudioPlayer";
const getFormattedDate = (_date) => {
  const date = new Date(_date);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = months[date.getMonth()];
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  const formattedDate = `${month} ${day}, ${hours}:${minutes}:${seconds}`;
  return formattedDate;
};

const RecentCall = ({ items, missed, visits, recents }) => {
  const [activeTab, setActiveTab] = useState("incoming");
  const [duration, setDuration] = useState(null);

  let filteredItems = items;
  if (recents) {
    filteredItems = items.filter((call) => {
      if (activeTab === "incoming") {
        return (
          call.call_direction === "incoming" || call.call_direction === null
        );
      } else {
        return call.call_direction === "outgoing";
      }
    });
  }

  if (missed) {
    filteredItems = items.filter((call) => {
      if (activeTab === "incoming") {
        return (
          call.call_direction === "incoming" || call.call_direction === null
        );
      } else {
        return call.call_direction === "outgoing";
      }
    });
  }

  return (
    <div className="recent-call-container">
      {(missed || recents) && (
        <div className="call-center__tabs">
          <button
            className={`call-center__tabs__tab ${
              activeTab === "incoming" ? "active" : ""
            }`}
            onClick={() => setActiveTab("incoming")}
          >
            Calls from Client to Agents
          </button>
          <button
            className={`call-center__tabs__tab ${
              activeTab === "outgoing" ? "active" : ""
            }`}
            onClick={() => setActiveTab("outgoing")}
          >
            Calls from Agent to Client
          </button>
        </div>
      )}

      {/* Call list */}
      <div className="call-center__section__list__inner">
        {filteredItems.length > 0 ? (
          filteredItems.map((call, index) => (
            <div
              key={`${call.callId}-${index}`}
              className="call-center__section__list__item"
            >
              <div className="call-center__section__list__item__user">
                <div className="call-center__section__list__item__user__name">
                  <span
                    style={
                      missed && call.call_direction === "incoming"
                        ? { color: "#E80A36" }
                        : {}
                    }
                  >
                    {call.clientName && call.clientName.includes("[PoC]")
                      ? call.clientId
                      : call.clientName}
                    {!call.clientName && call.clientId}
                  </span>
                  <div className="call-center__section__list__item__time__missed">
                    {call.group}
                  </div>
                </div>
              </div>
              <div className="call-center__section__list__item__info">
                <a
                  href={call.user_source}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="call-center__section__list__item__info__issue"
                >
                  {call.user_source}
                </a>
              </div>
              {missed && (
                <div className="call-center__section__list__item__time">
                  <div className="call-center__section__list__item__time__missed">
                    {call.call_direction === "incoming" && (
                      <div className="call-center__section__list__item__time__missed__icon" />
                    )}
                    {getFormattedDate(call.startTime)}
                  </div>
                </div>
              )}
              {!missed && (
                <div className="call-center__section__list__item__time">
                  {!visits && (
                    <div className="call-center__section__list__item__time__missed">
                      <AudioPlayer
                        callId={call.callId}
                        state={call.state}
                        setDuration={setDuration}
                        src={`https://callcenter-recordings.teech.tv/recordings/recording-${call.callId}.mp3`}
                      />
                    </div>
                  )}
                  <div style={{ textAlign: "right" }}>
                    {getFormattedDate(call.startTime)}
                  </div>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="call-center__no-calls">No calls found</div>
        )}
      </div>
    </div>
  );
};

export default RecentCall;
